import PropTypes from 'prop-types';
import React from 'react';

class LoginLayout extends React.Component {
  static propTypes = {
    children: PropTypes.object,
    className: PropTypes.string,
  };

  render() {
    return (
      <div className={this.props.className} id="m_login">
        <div className="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside">
          <div className="m-stack m-stack--hor m-stack--desktop">
            <div className="m-stack__item m-stack__item--fluid">{this.props.children}</div>
          </div>
        </div>
        <div
          className="m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1	m-login__content"
          style={{
            backgroundImage: 'url(assets/app/media/img/bg/bg-4.jpg)',
          }}
        >
          <div className="m-grid__item">
            <img src="assets/app/media/img/logos/CAS.png" alt="Crew Accreditation System" />
          </div>
        </div>
      </div>
    );
  }
}

export default LoginLayout;
